<template>
    <div id="app">
        <div v-if="isLoading" class="fixed flex justify-center flex-col items-center w-full h-full z-top">
            <div class="w-1/6 py-10 mx-auto shadow bg-white flex items-center justify-center flex-col rounded">
                <img src="/sixnet-logo.svg" class="w-24 h-24">
                <div class="text-sm font-light text-orange-500 mt-4">Načítanie ({{refCount}})</div>
            </div>
        </div>
        
        <transition-page>
            <router-view />
        </transition-page>
        
    </div>
</template>
<script>
    import {mapState} from "vuex";
    import ClickOutside from 'vue-click-outside'
    import TransitionPage from './components/TransitionPage';

    export default {
        metaInfo() {
            return {
                titleTemplate: (titleChunk) => {
                    return (titleChunk ? titleChunk + ' - ' : '') + this.$appName;
                }
            }
        },
        
        created() {
            this.axios.interceptors.request.use((config) => {
                this.$store.commit('loading', true);
                return config
            }, (error) => {
                this.$store.commit('loading', false);
                return Promise.reject(error)
            });

            this.axios.interceptors.response.use((response) => {
                this.$store.commit('loading', false);
                return response
            }, (error) => {
                this.$store.commit('loading', false);
                return Promise.reject(error)
            });
            
        },

        components: {
            TransitionPage
        },
        
        computed: {
            ...mapState(['isLoading', 'refCount'])
        },

        directives: {
            ClickOutside
        }
    }
</script>
